<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
// import { post } from './utils/request'

export default {
  name: 'App',
  data () {
    return {
      formData: {
        deveiceNo: '0001',
        businessNo:'3310807850210923175586',
        payMoney:'4'
      }
    }
  },
  mounted () {
  // post('/wxpay.php', this.formData).then(function (response) {
  //     console.log('AAAAAAAAAAAAAAAAAAAAAA',response)
  //   }).catch(function (error) {
  //     console.log(error, 'bbbbbbbbbbbbbbbbbb')
  //   })
  //    axios.get(this.formData).then(res=>{
  //       console.log("页面展示",res);
  //     }).catch(err=>{})

  },
  methods: {
  }

}

</script>

<style>
body{
  background: #fff;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  /* background: red; */
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue